// extracted by mini-css-extract-plugin
export default {"main":"SharedLayout_main__dj9bG","mainContentWrapper":"SharedLayout_mainContentWrapper__0iHHZ"};